import { permissionsFormToUpdate, permissionsQueryToForm } from './permissions-helper';
import type { UserRoleFormSchema, UserRoleQuerySchema } from './schemas';

export function userRoleQueryToForm(data: UserRoleQuerySchema): UserRoleFormSchema {
  return {
    ...data,
    azure_role_id: data.azure_role_id || '',
    permissions: permissionsQueryToForm(data.permissions),
  };
}

export function userRoleFormToMutation({ permissions, ...rest }: UserRoleFormSchema) {
  return {
    ...rest,
    permissions: permissionsFormToUpdate(permissions),
  };
}
